import { Component } from '@angular/core';
import { SpinnerService } from '@core/spinner/spinner.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-global-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent {
  //loading$: any;
  //_spinner: any;
  loading$!: Observable<boolean>;

  constructor(private spinnerService: SpinnerService) {

    this.loading$ = this.spinnerService.loading$;
    //this._spinner = spinnerService;
  }
 
}